import React, { useState, useEffect } from 'react';
import UserForm from './UserForm';
import UserList from './UserList';

const ClientsPage = ({ users }) => {

  const [clients, setClients]                 = useState([]);
  const [loading, setLoading]                 = useState(true);
  const [editingClient, setEditingClient]     = useState(null);
  const [selectedClient, setSelectedClient]   = useState(null);
  const [payments, setPayments]               = useState([]);
  const [showPaymentForm, setShowPaymentForm] = useState(false);
  const [showClientForm, setShowClientForm]   = useState(false);

  const [clientForm, setClientForm] = useState({
    user_id: '', business_name: '', contact_name: '', phone: '',
    whatsapp: '', email: '', address: '', rfc: '', notes: '',
    monthly_fee: '', billing_day: '1', status: 'activo'
  });

  const [paymentForm, setPaymentForm] = useState({
    amount: '', payment_method: 'Transferencia',
    payment_date: new Date().toISOString().split('T')[0],
    period: new Date().toISOString().slice(0, 7), notes: ''
  });

  const fetchClients = async () => {
    setLoading(true);
    try {
      const res  = await fetch('/api/admin/clients/list_clients.php', { credentials: 'include' });
      const data = await res.json();
      if (data.success) setClients(data.data || []);
    } catch (e) { console.error(e); }
    finally { setLoading(false); }
  };

  const fetchPayments = async (clientId) => {
    try {
      const res  = await fetch(`/api/admin/clients/list_payments.php?client_id=${clientId}`, { credentials: 'include' });
      const data = await res.json();
      if (data.success) setPayments(data.data || []);
    } catch (e) { console.error(e); }
  };

  useEffect(() => { fetchClients(); }, []);

  const handleOpenClient = async (client) => {
    setSelectedClient(client);
    await fetchPayments(client.id);
  };

  const handleSaveClient = async () => {
    const payload = {
      ...clientForm,
      user_id:     Number(clientForm.user_id),
      monthly_fee: parseFloat(clientForm.monthly_fee) || 0,
      billing_day: parseInt(clientForm.billing_day)   || 1,
    };
    if (editingClient) payload.id = editingClient.id;
    try {
      const res  = await fetch('/api/admin/clients/save_client.php', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        credentials: 'include', body: JSON.stringify(payload)
      });
      const data = await res.json();
      if (data.success) {
        await fetchClients();
        setShowClientForm(false);
        setEditingClient(null);
        setClientForm({
          user_id: '', business_name: '', contact_name: '', phone: '',
          whatsapp: '', email: '', address: '', rfc: '', notes: '',
          monthly_fee: '', billing_day: '1', status: 'activo'
        });
      }
    } catch (e) { console.error(e); }
  };

  const handleSavePayment = async () => {
    if (!selectedClient) return;
    const payload = { ...paymentForm, client_id: selectedClient.id };
    try {
      const res  = await fetch('/api/admin/clients/save_payment.php', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        credentials: 'include', body: JSON.stringify(payload)
      });
      const data = await res.json();
      if (data.success) {
        await fetchPayments(selectedClient.id);
        await fetchClients();
        setShowPaymentForm(false);
        setPaymentForm({
          amount: '', payment_method: 'Transferencia',
          payment_date: new Date().toISOString().split('T')[0],
          period: new Date().toISOString().slice(0, 7), notes: ''
        });
      }
    } catch (e) { console.error(e); }
  };

  const handleDeleteClient = async (clientId) => {
    if (!window.confirm('¿Eliminar este cliente?')) return;
    try {
      const res  = await fetch('/api/admin/clients/delete_client.php', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        credentials: 'include', body: JSON.stringify({ id: clientId })
      });
      const data = await res.json();
      if (data.success) {
        await fetchClients();
        if (selectedClient?.id === clientId) setSelectedClient(null);
      }
    } catch (e) { console.error(e); }
  };

  const handleDeletePayment = async (paymentId) => {
    if (!window.confirm('¿Eliminar este pago?')) return;
    try {
      const res  = await fetch('/api/admin/clients/delete_payment.php', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        credentials: 'include', body: JSON.stringify({ id: paymentId })
      });
      const data = await res.json();
      if (data.success && selectedClient) await fetchPayments(selectedClient.id);
    } catch (e) { console.error(e); }
  };

  if (loading) return <p className="text-[#3F1907]">Cargando clientes...</p>;

  return (
    <div className="space-y-6">

      <div className="flex justify-between items-center">
        <h3 className="text-lg font-semibold text-[#3F1907]">Clientes de suscripción</h3>
        <button
          onClick={() => {
            setEditingClient(null);
            setClientForm({
              user_id: '', business_name: '', contact_name: '', phone: '',
              whatsapp: '', email: '', address: '', rfc: '', notes: '',
              monthly_fee: '', billing_day: '1', status: 'activo'
            });
            setShowClientForm(true);
          }}
          className="bg-[#3F1907] text-[#F9EFD7] px-4 py-2 rounded-md text-sm font-semibold"
        >
          + Nuevo cliente
        </button>
      </div>

      {showClientForm && (
        <div className="bg-white border border-[#e8d5c4] rounded-xl p-4 space-y-3">
          <h4 className="font-semibold text-[#3F1907]">
            {editingClient ? 'Editar cliente' : 'Nuevo cliente'}
          </h4>
          {[
            { key: 'business_name', label: 'Nombre del negocio' },
            { key: 'contact_name',  label: 'Nombre de contacto' },
            { key: 'phone',         label: 'Teléfono' },
            { key: 'whatsapp',      label: 'WhatsApp' },
            { key: 'email',         label: 'Email' },
            { key: 'address',       label: 'Dirección' },
            { key: 'rfc',           label: 'RFC' },
          ].map(({ key, label }) => (
            <input
              key={key}
              placeholder={label}
              value={clientForm[key]}
              onChange={e => setClientForm(f => ({ ...f, [key]: e.target.value }))}
              className="w-full px-3 py-2 border border-[#ccc] rounded-md text-sm"
            />
          ))}
          <div className="flex gap-3">
            <input
              placeholder="Cuota mensual"
              type="number"
              value={clientForm.monthly_fee}
              onChange={e => setClientForm(f => ({ ...f, monthly_fee: e.target.value }))}
              className="flex-1 px-3 py-2 border border-[#ccc] rounded-md text-sm"
            />
            <input
              placeholder="Día de cobro"
              type="number"
              min="1" max="28"
              value={clientForm.billing_day}
              onChange={e => setClientForm(f => ({ ...f, billing_day: e.target.value }))}
              className="w-24 px-3 py-2 border border-[#ccc] rounded-md text-sm"
            />
          </div>
          <select
            value={clientForm.status}
            onChange={e => setClientForm(f => ({ ...f, status: e.target.value }))}
            className="w-full px-3 py-2 border border-[#ccc] rounded-md text-sm"
          >
            <option value="activo">Activo</option>
            <option value="suspendido">Suspendido</option>
            <option value="cancelado">Cancelado</option>
          </select>
          <textarea
            placeholder="Notas"
            value={clientForm.notes}
            onChange={e => setClientForm(f => ({ ...f, notes: e.target.value }))}
            className="w-full px-3 py-2 border border-[#ccc] rounded-md text-sm"
            rows={2}
          />
          <div className="flex gap-2">
            <button
              onClick={() => setShowClientForm(false)}
              className="flex-1 py-2 rounded-md border border-[#ccc] text-sm"
            >Cancelar</button>
            <button
              onClick={handleSaveClient}
              className="flex-2 px-6 py-2 rounded-md bg-[#3F1907] text-[#F9EFD7] text-sm font-semibold"
            >Guardar</button>
          </div>
        </div>
      )}

      {clients.length === 0 ? (
        <p className="text-gray-500 text-sm">Sin clientes registrados.</p>
      ) : (
        clients.map(c => (
          <div key={c.id} className="bg-white border border-[#e8d5c4] rounded-xl p-4">
            <div className="flex justify-between items-start">
              <div>
                <p className="font-bold text-[#3F1907]">{c.business_name || c.contact_name}</p>
                <p className="text-sm text-gray-500">{c.phone} · {c.email}</p>
                <p className="text-sm text-gray-500">
                  Cuota: ${Number(c.monthly_fee).toFixed(2)} · Día {c.billing_day}
                </p>
                {c.days_until_due <= 5 && (
                  <span className="text-xs text-red-600 font-semibold">
                    ⚠️ Vence en {c.days_until_due} días
                  </span>
                )}
              </div>
              <div className="flex gap-2 flex-shrink-0">
                <button
                  onClick={() => handleOpenClient(c)}
                  className="text-xs px-3 py-1 bg-[#58735A] text-white rounded-md"
                >Ver pagos</button>
                <button
                  onClick={() => {
                    setEditingClient(c);
                    setClientForm({
                      user_id:       c.user_id       || '',
                      business_name: c.business_name || '',
                      contact_name:  c.contact_name  || '',
                      phone:         c.phone         || '',
                      whatsapp:      c.whatsapp       || '',
                      email:         c.email          || '',
                      address:       c.address        || '',
                      rfc:           c.rfc            || '',
                      notes:         c.notes          || '',
                      monthly_fee:   c.monthly_fee    || '',
                      billing_day:   c.billing_day    || '1',
                      status:        c.status         || 'activo'
                    });
                    setShowClientForm(true);
                  }}
                  className="text-xs px-3 py-1 bg-[#3F1907] text-white rounded-md"
                >Editar</button>
                <button
                  onClick={() => handleDeleteClient(c.id)}
                  className="text-xs px-3 py-1 bg-red-600 text-white rounded-md"
                >Eliminar</button>
              </div>
            </div>

            {selectedClient?.id === c.id && (
              <div className="mt-4 border-t border-[#e8d5c4] pt-4">
                <div className="flex justify-between items-center mb-3">
                  <p className="font-semibold text-sm text-[#3F1907]">Historial de pagos</p>
                  <button
                    onClick={() => setShowPaymentForm(true)}
                    className="text-xs px-3 py-1 bg-[#58735A] text-white rounded-md"
                  >+ Registrar pago</button>
                </div>

                {showPaymentForm && (
                  <div className="bg-[#fdf8f5] border border-[#e8d5c4] rounded-lg p-3 mb-3 space-y-2">
                    <input
                      type="number" placeholder="Monto"
                      value={paymentForm.amount}
                      onChange={e => setPaymentForm(f => ({ ...f, amount: e.target.value }))}
                      className="w-full px-3 py-2 border border-[#ccc] rounded-md text-sm"
                    />
                    <select
                      value={paymentForm.payment_method}
                      onChange={e => setPaymentForm(f => ({ ...f, payment_method: e.target.value }))}
                      className="w-full px-3 py-2 border border-[#ccc] rounded-md text-sm"
                    >
                      <option>Efectivo</option>
                      <option>Transferencia</option>
                      <option>Tarjeta</option>
                      <option>Otro</option>
                    </select>
                    <input
                      type="date"
                      value={paymentForm.payment_date}
                      onChange={e => setPaymentForm(f => ({ ...f, payment_date: e.target.value }))}
                      className="w-full px-3 py-2 border border-[#ccc] rounded-md text-sm"
                    />
                    <input
                      type="month"
                      value={paymentForm.period}
                      onChange={e => setPaymentForm(f => ({ ...f, period: e.target.value }))}
                      className="w-full px-3 py-2 border border-[#ccc] rounded-md text-sm"
                    />
                    <textarea
                      placeholder="Notas"
                      value={paymentForm.notes}
                      onChange={e => setPaymentForm(f => ({ ...f, notes: e.target.value }))}
                      className="w-full px-3 py-2 border border-[#ccc] rounded-md text-sm"
                      rows={2}
                    />
                    <div className="flex gap-2">
                      <button
                        onClick={() => setShowPaymentForm(false)}
                        className="flex-1 py-2 rounded-md border border-[#ccc] text-sm"
                      >Cancelar</button>
                      <button
                        onClick={handleSavePayment}
                        className="flex-1 py-2 rounded-md bg-[#3F1907] text-[#F9EFD7] text-sm font-semibold"
                      >Guardar</button>
                    </div>
                  </div>
                )}

                {payments.length === 0 ? (
                  <p className="text-sm text-gray-400">Sin pagos registrados.</p>
                ) : (
                  payments.map(p => (
                    <div key={p.id} className="flex justify-between items-center py-2 border-b border-[#f0f0f0] text-sm">
                      <div>
                        <p className="font-medium text-[#3F1907]">${Number(p.amount).toFixed(2)} — {p.payment_method}</p>
                        <p className="text-xs text-gray-400">{p.payment_date} · Periodo: {p.period}</p>
                        {p.notes && <p className="text-xs text-gray-400">{p.notes}</p>}
                      </div>
                      <button
                        onClick={() => handleDeletePayment(p.id)}
                        className="text-xs text-red-500 hover:text-red-700"
                      >Eliminar</button>
                    </div>
                  ))
                )}
              </div>
            )}
          </div>
        ))
      )}
    </div>
  );
};

const AdminPage = () => {

  const [activeTab, setActiveTab]     = useState('usuarios');
  const [users, setUsers]             = useState([]);
  const [editingUser, setEditingUser] = useState(null);
  const [loading, setLoading]         = useState(false);
  const [error, setError]             = useState(null);
  const [alertCount, setAlertCount]   = useState(0);

  const fetchUsers = async () => {
    setLoading(true);
    try {
      const res  = await fetch('/api/admin/list_users.php', { credentials: 'include' });
      const data = await res.json();
      if (data.success) setUsers(data.users || []);
    } catch (e) { console.error(e); }
    finally { setLoading(false); }
  };

  const checkAlerts = async () => {
    try {
      const res  = await fetch('/api/admin/clients/list_clients.php', { credentials: 'include' });
      const data = await res.json();
      if (data.success) {
        const count = (data.data || []).filter(c => c.days_until_due <= 5).length;
        setAlertCount(count);
      }
    } catch (e) { console.error(e); }
  };

  useEffect(() => { fetchUsers(); checkAlerts(); }, []);

  const handleCreateUser = async (userData) => {
    setLoading(true);
    setError(null);
    try {
      const res  = await fetch('/api/admin/create_user.php', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        credentials: 'include', body: JSON.stringify(userData)
      });
      const data = await res.json();
      if (data.success) await fetchUsers();
      else setError(data.error || data.message || 'Error al crear usuario');
    } catch (e) { setError('Error de conexión'); }
    finally { setLoading(false); }
  };

  const handleUpdateUser = async (userData) => {
    setLoading(true);
    setError(null);
    try {
      const res  = await fetch('/api/admin/update_user.php', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        credentials: 'include', body: JSON.stringify(userData)
      });
      const data = await res.json();
      if (data.success) await fetchUsers();
      else setError(data.error || data.message || 'Error al actualizar usuario');
    } catch (e) { setError('Error de conexión'); }
    finally { setLoading(false); }
  };

  const handleDeleteUser = async (userId) => {
    if (!window.confirm('¿Eliminar este usuario?')) return;
    setLoading(true);
    try {
      const res  = await fetch('/api/admin/delete_user.php', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        credentials: 'include', body: JSON.stringify({ id: userId })
      });
      const data = await res.json();
      if (data.success) await fetchUsers();
    } catch (e) { console.error(e); }
    finally { setLoading(false); }
  };

  const handleSaveUser = async (userData) => {
    if (editingUser) {
      await handleUpdateUser({ ...userData, id: editingUser.id });
      setEditingUser(null);
    } else {
      await handleCreateUser(userData);
    }
  };

  return (
    <div className="mt-6">

      {error && (
        <div className="mb-4 p-3 bg-red-100 text-red-700 rounded-md">{error}</div>
      )}
      {loading && (
        <div className="mb-4 p-3 bg-blue-100 text-blue-700 rounded-md">Procesando...</div>
      )}

      <div className="flex gap-2 mb-6">
        <button
          onClick={() => setActiveTab('usuarios')}
          className={`py-2 px-4 rounded-md ${
            activeTab === 'usuarios'
              ? 'bg-[#58735A] text-[#F9EFD7]'
              : 'bg-gray-300 text-gray-700'
          }`}
        >
          Usuarios
        </button>

        <button
          onClick={() => setActiveTab('clientes')}
          className={`py-2 px-4 rounded-md ${
            activeTab === 'clientes'
              ? 'bg-[#58735A] text-[#F9EFD7]'
              : 'bg-gray-300 text-gray-700'
          }`}
        >
          Clientes
          {alertCount > 0 && (
            <span style={{
              marginLeft: 6, background: '#EF4444', color: 'white',
              fontSize: 10, borderRadius: '50%', padding: '2px 6px'
            }}>
              {alertCount}
            </span>
          )}
        </button>
      </div>

      {activeTab === 'usuarios' && (
        <>
          <div className="bg-[#F9EFD7] p-4 rounded-lg shadow mb-6">
            <h3 className="text-lg font-semibold text-[#3F1907] mb-3">
              {editingUser ? 'Editar Usuario' : 'Crear Nuevo Usuario'}
            </h3>
            <UserForm
              editingUser={editingUser}
              onSaveUser={handleSaveUser}
              onCancelEdit={() => setEditingUser(null)}
              disabled={loading}
            />
          </div>

          <div className="bg-[#F9EFD7] p-4 rounded-lg shadow">
            <h3 className="text-lg font-semibold text-[#3F1907] mb-3">Usuarios Existentes</h3>
            <UserList
              users={users}
              onDeleteUser={handleDeleteUser}
              onEditUser={setEditingUser}
            />
          </div>
        </>
      )}

      {activeTab === 'clientes' && (
        <div className="bg-[#F9EFD7] p-4 rounded-lg shadow">
          <ClientsPage users={users} />
        </div>
      )}

    </div>
  );
};

export default AdminPage;